import HomeLayout from '@/layouts/HomeLayout';
import { createInertiaApp } from '@inertiajs/react'
import '../lib/i18n'
import { ReactNode } from 'react';

type InertiaPageModule = {
  default: React.ComponentType<any> & {
    layout?: (page: ReactNode) => ReactNode;
  };
}

void createInertiaApp({
  pages: "../pages/",

  strictMode: true,

  title: (title) => `Full Packing del Caribe | ADM | ${title}`,

  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx', { eager: true }) as Record<string, InertiaPageModule>;
    let page = pages[`../pages/${name}.tsx`];

    if (!page) {
      throw new Error(`Page not found: ../pages/${name}.tsx`);
    }

    page.default.layout = page.default.layout || ((page: ReactNode) => <HomeLayout children={page} />);

    return page;
  },

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})
